import { defineStore, storeToRefs } from "pinia"
import { computed } from "vue"
import { useOrderStore } from "@/store/orders.store"
import { Message } from "@/models/message.model"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import type { Order } from "@/models/order.model"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager"

export const useMessageStore = defineStore("messageStore", () => {
  const orderStore = useOrderStore()
  const { orders } = storeToRefs(orderStore)

  const messages = computed<Message[]>(() => {
    const messages = []
    for (const order of orders.value) {
      if (order.messages) {
        messages.push(...order.messages)
      }
    }
    return messages
  })

  const { pushToRelatedObjects, removeFromRelatedObjects } = useRelatedObjectsManager(
    orders,
    (message: Message) => message.order,
    (order: Order) => order.id,
    (order: Order) => order.messages
  )
  useSocketSynchronizationHandlers(Message, null, pushToRelatedObjects, removeFromRelatedObjects)

  return {
    messages,
    pushToRelatedObjects,
    removeFromRelatedObjects
  }
})
